<template>
  <div class="all-training-reports" v-if="userData.trialistId !== null">
    <h3>Trialiest Performance review</h3>
    <a v-if="!$store.getters.isReadOnlySeason" href="javascript:;" class="view-all-reports" @click="openModal()"
      ><img class="large-icon-shape" src="./img/trial-icon-big.svg" alt="" />
      <span>Add trialiest <br />Performance review</span></a
    >
  </div>

  <b-modal
    v-if="trialPerformanceReview"
    v-model="trialPerformanceReview"
    size="lg"
    title="Trialiest Performance review"
    hide-footer
  >
    <div class="profile-page">
      <div class="intro-header" style="width: 100%">
        <div class="user-photo-info">
          <img
            id="user_photo"
            v-if="userData.userImage !== '' && userData.userImage !== null"
            :src="getImgUrl(userData.userImage)"
            alt=""
          />
          <TenantLogo v-else id="main-logo" logo-class="" />
        </div>

        <div class="sessons-header">
          <div class="header-buttons">
            <span class="week-selected-dates-text">
              <span class="selected-user"
                >Name:
                <span class="highlighted-text"> {{ userData.name }}</span>
              </span>
              <span class="selected-user"
                >DOB:
                <span class="highlighted-text">
                  {{ dayMonthYear(userData.dob) }}</span
                >
              </span>
              <span class="selected-user"
                >Age group:
                <span class="highlighted-text"> {{ userData.age_group }}</span>
              </span>

              <span class="selected-user">
                Trial length:
                <span class="highlighted-text">
                  {{ selectedTrialistsData.trial_length }} weeks
                </span>
              </span>

              <span class="selected-user">
                Trial time left:
                <span
                  class="trial-ended"
                  v-if="
                    getTimeLeftInTrial(
                      selectedTrialistsData.trial_start_date,
                      selectedTrialistsData.trial_length,
                    ) === 'Trial period has ended.'
                  "
                  >{{
                    getTimeLeftInTrial(
                      selectedTrialistsData.trial_start_date,
                      selectedTrialistsData.trial_length,
                    )
                  }}</span
                >
                <span class="trial-in-progress" v-else>{{
                  getTimeLeftInTrial(
                    selectedTrialistsData.trial_start_date,
                    selectedTrialistsData.trial_length,
                  )
                }}</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="trial-performance-wrapper">
      <div class="form__item">
        <label class="form__label" for="attitude">Attitude</label>
        <div class="ratingStars">
          <vue3-star-ratings
            v-model="selectedTrialistsData.attitude"
            :star-size="25"
          />
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="skill">Skill</label>
        <div class="ratingStars">
          <vue3-star-ratings
            v-model="selectedTrialistsData.skill"
            :star-size="25"
          />
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="physique">Physique</label>
        <div class="ratingStars">
          <vue3-star-ratings
            v-model="selectedTrialistsData.physique"
            :star-size="25"
          />
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="physique">Mentality</label>
        <div class="ratingStars">
          <vue3-star-ratings
            v-model="selectedTrialistsData.mentality"
            :star-size="25"
          />
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="physique">Leadership</label>
        <div class="ratingStars">
          <vue3-star-ratings
            v-model="selectedTrialistsData.leadership"
            :star-size="25"
          />
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="physique">Professionalism</label>
        <div class="ratingStars">
          <vue3-star-ratings
            v-model="selectedTrialistsData.professionalism"
            :star-size="25"
          />
        </div>
      </div>

      <div class="form__item">
        <label class="form__label" for="comments">Comments</label>
        <QuillEditor
          v-model:content="selectedTrialistsData.comments"
          contentType="html"
          theme="snow"
        />
      </div>
    </div>

    <div class="form__item">
      <button
        @click="saveTrialistPerformanceReview()"
        class="green-button"
        :disabled="isLoading"
      >
        <span v-if="isLoading">Saving...</span>
        <span v-else>Save Performance review</span>
      </button>
    </div>
  </b-modal>
</template>

<script>
import { Trialists } from "@/services/trialist-service.js";
import { Users } from "@/services/user-service.js";
import { QuillEditor } from "@vueup/vue-quill";
import dayjs from "dayjs";
import TenantLogo from "@/components/TenantLogo/index.vue";

export default {
  name: "TrialPerformanceReview",
  components: { QuillEditor, TenantLogo },
  data() {
    return {
      isLoading: false,
      trialPerformanceReview: false,
      userData: {},
      selectedTrialistsData: {},
    };
  },
  props: {
    selectedUserValue: {
      type: Number,
      default: () => undefined,
    },
  },
  mounted() {
    if (this.selectedUserValue !== undefined) {
      this.getUserById();
    }
  },
  methods: {
    getTimeLeftInTrial(trialStartDate, trialLength) {
      if (!trialStartDate || !trialLength)
        return "Trial information incomplete.";

      const start = dayjs(trialStartDate);
      const end = start.add(parseInt(trialLength) * 7, "day");
      const now = dayjs();

      if (now.isBefore(start))
        return `Starts in ${start.diff(now, "day")} days`;
      if (now.isAfter(end)) return "Trial ended";

      const days = end.diff(now, "day");
      const hours = end.diff(now, "hour") % 24;

      return days > 0 ? `${days}d ${hours}h remaining` : `${hours}h remaining`;
    },
    getImgUrl(pic) {
      return pic !== undefined && pic !== "" ? `/images/${pic}` : "";
    },
    dayMonthYear(date) {
      return dayjs(date).format("D MMM YYYY");
    },
    openModal() {
      this.trialPerformanceReview = true;
    },
    formatDatesForDb(date) {
      if (!date) return null;
      return dayjs(date).format("YYYY-MM-DD");
    },
    async getUserById() {
      const userData = {
        clientId: this.selectedUserValue,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        console.log(responce.data[0]);
        this.userData = responce.data[0];
        if (this.userData.trialistId !== null) {
          this.getTrialistById();
        }
      }
    },
    async getTrialistById() {
      try {
        this.isLoading = true;

        const userData = {
          action: "getTrialistById",
          id: this.userData.trialistId,
        };

        const response = await Trialists.find(userData);

        if (response && response.status === 200) {
          console.log("Trialist data fetched successfully:", response.data);
          this.selectedTrialistsData = response.data;
        }
      } catch (error) {
        console.error("Error updating trialist:", error);
      } finally {
        this.isLoading = false;
        this.$emit("loading-changed", false);
      }
    },
    async saveTrialistPerformanceReview() {
      try {
        this.isLoading = true;

        const userData = {
          action: "updateTrialPerformanceReviewOnly",
          ...this.selectedTrialistsData,
        };

        const response = await Trialists.find(userData);

        if (response && response.status === 200) {
          this.$toast.info("Trialist updated.", {
            title: "Updated",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          });

          this.trialPerformanceReview = false;
        } else {
          throw new Error("Failed to update trialist");
        }
      } catch (error) {
        console.error("Error updating trialist:", error);
        this.$toast.error("Failed to update trialist. Please try again.", {
          title: "Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.view-all-reports {
  border: 1px solid #c3cdd5;
  padding: 1rem;
  display: flex;
  margin-bottom: 1rem;
  border-radius: 4px;
  font-weight: bold;
  text-decoration: none;
  min-width: 18rem;

  &:hover,
  &:focus {
    background: #47a9f9;
    color: white;
    text-decoration: none;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.green-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.green-button:disabled:hover {
  opacity: 0.6;
}
</style>
